/* ─── FEATURED REPORTS (downloadable work samples) ─── */
export const WORK_SAMPLES = [
  {
    title: "Strengthening Support Ecosystems for Digital Democracy — Côte d'Ivoire",
    org: "Digital Democracy Initiative · CIVICUS",
    type: "Case Study Assessment",
    place: "Côte d'Ivoire",
    year: "Mar 2025",
    desc: "Assessment of the support systems available to civil-society organisations advancing digital democracy in a restrictive civic environment, with recommendations to strengthen the ecosystem.",
    tags: ["Civic Space", "Africa"],
    file: "/work-samples/ddi_civ.pdf",
    size: "410 KB",
  },
  {
    title: "Strengthening Support Ecosystems for Digital Democracy — Egypt",
    org: "Digital Democracy Initiative · CIVICUS",
    type: "Case Study Assessment",
    place: "Egypt",
    year: "Mar 2025",
    desc: "Examines how CSOs navigate digital repression and restrictive policy in Egypt, the innovative strategies they deploy, and the support needed to advance digital democracy.",
    tags: ["Civic Space", "MENA"],
    file: "/work-samples/ddi_egypt.pdf",
    size: "563 KB",
  },
  {
    title: "Strengthening Support Ecosystems for Digital Democracy — Uganda",
    org: "Digital Democracy Initiative · CIVICUS",
    type: "Case Study Assessment",
    place: "Uganda",
    year: "Mar 2025",
    desc: "Assesses support systems for CSOs promoting digital democracy under restricted civic freedoms, with practical recommendations to strengthen support mechanisms in-country.",
    tags: ["Civic Space", "Africa"],
    file: "/work-samples/ddi_uganda.pdf",
    size: "673 KB",
  },
  {
    title: "EduSpots' Model — An Independent Evaluation",
    org: "EduSpots · delivered with Expectation State",
    type: "Independent Evaluation",
    place: "Ghana",
    year: "Feb 2025",
    desc: "Outcome Harvesting–based independent evaluation of the EduSpots community-driven education model across Ghana — assessing effectiveness, impact and recommendations for scale.",
    tags: ["Education", "Africa"],
    file: "/work-samples/eduspots_evaluation.pdf",
    size: "2.1 MB",
  },
  {
    title: "ACTIVATE — GESI-Integrated Labour Market Assessment",
    org: "WUSC Ghana · Mastercard Foundation",
    type: "Learning Brief",
    place: "Ghana",
    year: "Mar 2025",
    desc: "Gender Equality & Social Inclusion–integrated labour market analysis for the agricultural-TVET ACTIVATE programme, surfacing enrolment inequities and a roadmap for inclusive employment.",
    tags: ["Livelihoods", "Africa"],
    file: "/work-samples/wusc_activate_labour_market_brief.pdf",
    size: "3.7 MB",
  },
  {
    title: "Mapping CSO Engagement in Internet Governance (Annex 1)",
    org: "CADE — Civil Society Alliances for Digital Empowerment · EU-funded",
    type: "Research Study",
    place: "Global / Global South",
    year: "Jan 2025",
    desc: "Mixed-methods mapping of civil-society engagement in multilateral and multistakeholder internet governance, identifying barriers — funding, technical jargon, diversity — to Global South participation.",
    tags: ["Civic Space", "Global"],
    file: "/work-samples/ig_annex1_mapping_cso.pdf",
    size: "2.9 MB",
  },
  {
    title: "CSO Engagement in Internet Governance — Baseline & Recommendations (Annex 2)",
    org: "CADE — Civil Society Alliances for Digital Empowerment · EU-funded",
    type: "Baseline & Recommendations",
    place: "Global / Global South",
    year: "Jan 2025",
    desc: "Establishes a baseline of CSO participation, capacity and effectiveness in internet governance and sets out actionable recommendations to make these processes more inclusive and equitable.",
    tags: ["Civic Space", "Global"],
    file: "/work-samples/ig_annex2_baseline_recommendations.pdf",
    size: "622 KB",
  },
  {
    title: "From Creation to Innovation — Mid-Term Evaluation",
    org: "SPARK · European Union",
    type: "Mid-Term Evaluation",
    place: "Tunisia, Palestine, Lebanon & Jordan",
    year: "Oct 2024",
    desc: "Outcome Harvesting–based mid-term evaluation of SPARK's enterprise and innovation programme across the MENA region, assessing effects on innovation, employment and economic growth.",
    tags: ["Livelihoods", "MENA"],
    file: "/work-samples/eni_midterm_evaluation.pdf",
    size: "1.1 MB",
  },
  {
    title: "Innovation for Change (I4C) Africa Hub — Outcome & Impact Harvesting Evaluation",
    org: "I4C Africa Hub · Sida, USAID & Tides",
    type: "Outcome Harvesting Evaluation",
    place: "Pan-Africa (12+ countries)",
    year: "Sep 2023",
    desc: "Outcome Harvesting evaluation of the I4C Africa Hub (2017–2022), assessing impact, relevance and sustainability of its civic-space and human-rights work, with forward strategy recommendations.",
    tags: ["Civic Space", "Africa"],
    file: "/work-samples/i4c_africa_hub_evaluation.pdf",
    size: "6.5 MB",
  },
  {
    title: "Climate-Smart Risk Analysis & Forecasting — Final Evaluation",
    org: "IFRC · Swiss Agency for Development & Cooperation (SDC)",
    type: "Final Evaluation",
    place: "Global",
    year: "Dec 2022",
    desc: "Outcome Harvesting–based final evaluation of IFRC's climate-smart risk analysis and forecasting programme (2020–2022), assessing relevance and effectiveness for Red Cross / Red Crescent action.",
    tags: ["Climate", "Global"],
    file: "/work-samples/climate_smart_risk_forecasting.pdf",
    size: "562 KB",
  },
  {
    title: "On the Frontlines of Community Health — VHW Endline Evaluation",
    org: "Women's Refugee Commission · BSPHCDA · Gates Foundation",
    type: "Endline Evaluation",
    place: "Borno State, Nigeria",
    year: "May 2022",
    desc: "Endline evaluation of a Village Health Worker programme improving RMNCAHN services — evidencing increased service demand, improved health-seeking behaviour and community acceptance.",
    tags: ["Health", "Africa"],
    file: "/work-samples/vhw_endline_nigeria.pdf",
    size: "3.3 MB",
  },
  {
    title: "Increasing Access to RMNCAHN Services — Endline Evaluation",
    org: "Women's Refugee Commission · Gates Foundation",
    type: "Endline Evaluation",
    place: "Borno State, Nigeria",
    year: "Jun 2021",
    desc: "Contribution-analysis endline evaluation of an integrated RMNCAHN programme delivering reproductive, maternal, newborn, child and adolescent health services at community and PHC levels.",
    tags: ["Health", "Africa"],
    file: "/work-samples/rmncahn_borno_nigeria.pdf",
    size: "1.2 MB",
  },
  {
    title: "Localizing Humanitarian Aid — Consortium VHW Learning Brief",
    org: "Women's Refugee Commission · Gates Foundation",
    type: "Learning Brief",
    place: "Borno State, Nigeria",
    year: "Mar 2023",
    desc: "Synthesises learning from a consortium-based Village Health Worker programme on equitable, sustainable localization — local partnerships, government ownership and flexible funding.",
    tags: ["Humanitarian", "Africa"],
    file: "/work-samples/localizing_humanitarian_aid_borno.pdf",
    size: "1.9 MB",
  },
];

/* ─── REPORT FILTER CHIPS (sector / region) ─── */
export const REPORT_FILTERS = ["All", "Civic Space", "Health", "Education", "Livelihoods", "Climate", "Humanitarian", "Africa", "MENA", "Global"];
